import { TVariation } from 'core/pages/ProductNew-v2/types'

export const initialValues = [
  {
    reserved: 0,
    quantity: null,
    name: 'Magalu',
    channel: 'magazineluiza',
    branch: 'ULA01',
    type: 'on_seller',
  },
]

export type TInitialValues = {
  stocks: {
    type: string
    channel: string
    branch: string
    reserved: number
    name: string
    quantity: number
  }[]
  variations: TVariation[]
  fulfillment: boolean
}

export const URL_MAGALU_CD = 'https://magaluentregas.com.br/fulfillment/gestao-de-estoque'

export const URL_MAGALU_FULFILLMENT = 'https://magaluentregas.com.br/fulfillment'
